export function formatPlayTime(seconds: number): string {
    seconds = Math.round(seconds);
    if (isNaN(seconds)) {
        return ``;
    }
    if (seconds < 60) {
        return `${seconds} sec`; // Less than a minute
    }

    const pad = (num: number) => num.toString().padStart(2, '0');
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const sec = seconds % 60;

    let timeString = '';

    if (hours > 0) {
        timeString += `${hours}:`;
    }

    if (minutes > 0 || timeString.length > 0) { // Check if hours were added
        timeString += `${timeString.length > 0 ? pad(minutes) : minutes}:`;
    }

    timeString += pad(sec);

    return timeString;
}